<template>
    <div class="m-content">

        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            {{ labels['manage_users_title'] }}
                        </h3>
                    </div>
                </div>
                <div class="m-portlet__head-tools">
                    <div id="m_quicksearch" m-quicksearch-mode="default" class="m-stack__item m-stack__item--middle m-dropdown m-dropdown--arrow m-dropdown--large m-dropdown--mobile-full-width m-dropdown--align-right m-dropdown--skin-light m-header-search m-header-search--expandable m-header-search--skin-light">
                        <form class="m-header-search__form">
                            <div class="m-header-search__wrapper">
                                <span id="m_quicksearch_search" class="m-header-search__icon-search"><i class="flaticon-search"></i></span>
                                <span class="m-header-search__input-wrapper">
                                    <input @keydown.enter.stop.prevent autocomplete="off" type="text" name="q" value="" placeholder="Search..." id="m_quicksearch_input" class="m-header-search__input" v-model="search">
                                </span>
                                <span id="m_quicksearch_cancel" class="m-header-search__icon-cancel" @click="clearKeywords" v-show="searchValue.length"><i class="la la-remove"></i></span>
                            </div>
                        </form>
                    </div>
                    <ul class="m-portlet__nav" style="list-style: none;">
                        <li class="m-portlet__nav-item">
                            <a @click.prevent.stop="setIndex({name: 'editIndex', value: 'new'})" href="#" class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon">
                                <span><i class="la la-plus"></i>
                                    <span>{{ labels['create_user'] }}</span>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="m-portlet__body">
                <div id="m_table_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer table-responsive">
                    <!--begin: Datatable -->
                    <table class="table table-striped- table-bordered table-hover table-checkable" id="m_table_1">
                        <thead class="thead-light">
                            <tr>
                                <th class="sorting column_head">{{ labels['firstname'] }}</th>
                                <th class="sorting column_head">{{ labels['lastname'] }}</th>
                                <th class="sorting column_head">{{ labels['email'] }}</th>
                                <th class="sorting column_head">{{ labels['user_roles'] }}</th>
                                <th class="column_head">{{ labels['actions'] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr class="'tr_form_new'" v-if="editIndex === 'new'">
                            <td colspan="11">
                                <user-form index="new"></user-form>
                            </td>
                        </tr>
                        <template v-for="(user, index) in paginatedUsers">
                            <user-row :key="'row_'+index" :user="user" :index="index"></user-row>
                            <tr :class="'tr_form' + index" :key="'tr_' + index" v-if="editIndex === index">
                                <td colspan="11">
                                    <user-form :key="'edit_'+index" :index="index" :user="user"></user-form>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>

                    <div class="row pagination-footer">
                        <div class="col-sm-12 col-md-5">
                            <div class="dataTables_info" id="m_table_1_info" role="status" aria-live="polite">{{ labels['showing'] }} {{ resultsLength }} du {{ results.totalRecords }} entries</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                            <div class="dataTables_paginate paging_simple_numbers" id="m_table_1_paginate" v-show="results.totalPages > 1">
                                <ul class="pagination">
                                    <li class="paginate_button page-item pagination-word">{{ labels.page }}</li>
                                    <li class="pagination-btn" :class="{ 'paginate_button page-item previous': true, 'disabled': page <= 0 }" id="m_table_1_previous">
                                        <a href="#" aria-controls="m_table_1" data-dt-idx="0" tabindex="0" class="page-link" @click.prevent="previousPage" :disabled="page <= 0"><i class="la la-angle-left"></i></a>
                                    </li>
                                    <li class="paginate_button page-item"><input class="form-control pagination-input" type="text" :value="page + 1" @keyup.enter="changePage($event.target.value - 1)"></li>
                                    <li class="pagination-btn" :class="{ 'paginate_button page-item next': true, 'disabled': (page + 1) >= results.totalPages }" id="m_table_1_next">
                                        <a href="#" aria-controls="m_table_1" data-dt-idx="6" tabindex="0" class="page-link" @click.prevent="nextPage" :disabled="(page + 1) >= results.totalPages">
                                            <i class="la la-angle-right"></i>
                                        </a>                                </li>
                                    <li class="paginate_button page-item pagination-word">{{ labels.of }} {{ results.totalPages }}</li>
                                </ul>
                                <div style="width: 100px; background-color: #0a8cf0"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form enctype="multipart/form-data">
            <label>Importer une liste d'utilisateurs (format CSV : prénom, nom, email, role) : </label>
            <input type="file" @change="onFileChange">
        </form>
    </div>

</template>

<script>
// 3rd party dependencies
import { mapState, mapActions } from 'vuex';
// Components
import Papa from 'papaparse';
import { HTTP } from '../../assets/js/axiosConfig';
import UserRow from './UserRow';
import UserForm from './UserForm';
import SweetAlert from '../../assets/js/mixins';
// Mixins
export default {
  name: 'ManageUsers',
  components: {
    UserRow,
    UserForm,
  },
  mixins: [SweetAlert],
  data() {
    return {
      searchValue: '',
      maxRecords: 8,
      page: 0,
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      users: (store) => store.users.users,
      results: (store) => store.users.results,
      indexes: (store) => store.users.indexes,
      editIndex: (store) => store.users.editIndex,
    }),
    filteredUsers() {
      const users = this.users.filter((user, index) => user.last_name.indexOf(this.searchValue) !== -1 || user.first_name.indexOf(this.searchValue) !== -1 || user.email.indexOf(this.searchValue) !== -1 || user.roles.indexOf(this.searchValue) !== -1);
      return users;
    },
    paginatedUsers() {
      const users = this.filteredUsers.filter((user, index) => index >= this.minRecords && index < this.maxRecords * (this.page + 1));
      return users;
    },
    search: {
      get() {
        return this.searchValue;
      },
      set(value) {
        this.page = 0;
        this.searchValue = value;
      },
    },
    minRecords() {
      return this.maxRecords * this.page;
    },
    resultsLength() {
      return this.paginatedUsers.length;
    },
  },
  methods: {
    ...mapActions('users/', [
      'getUsers',
      'setIndex',
    ]),
    changePage(page) {
      if (page >= 0 && (page + 1) <= this.results.totalPages) {
        this.page = page;
      }
    },
    previousPage() {
      this.page -= 1;
    },
    nextPage() {
      this.page += 1;
    },
    clearKeywords() {
      this.searchValue = '';
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createInput(files[0]);
    },
    createInput(myfile) {
      const my = this;
      Papa.parse(myfile, {
        complete(results) {
          const users = my.transformToUsers(results.data);
          console.log('Parsing complete:', users);
          my.importListUser(users);
        },
      });
    },
    transformToUsers(users) {
      return users.map((item) => ({
        firstname: item[0],
        lastname: item[1],
        email: item[2],
        roles: [item[3]],
      }));
    },
    importListUser(users) {
      HTTP.post('api/multi-users', {
        users,
      })
        .then(() => {
          // Do something on success
          // Alert on success
          this.sweetAlert('success', `L'import des ${users.length} utilisateurs est terminé.`, 3000);
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.sweetAlert('success', `L'import est terminé. Voici les erreurs que nous avons eu : ${err.response.data.message}`, 10000);
        });
    },
  },
  created() {
    // Make requests to get all users
    this.getUsers();
  },
  beforeDestroy() {
    this.setIndex({ name: 'editIndex', value: null });
  },
};
</script>

<style>

    .pagination-footer {
        margin-bottom: 4%;
    }

    .pagination-input {
        width: 55px;
    }

    .pagination-word {
        margin-top: 2%;
    }

    .pagination-btn {
        margin-top: 1%;
    }

</style>



// WEBPACK FOOTER //
// src/components/Users/ManageUsers.vue